import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';

import './EyeButton.scss';

const EyeButton = ({ onClick, isActive }) => {
  const { t } = useTranslation('sidebar');

  return (
    <button
      type='button'
      className='btn-visible'
      onClick={onClick}
      aria-label={t('toggleTableVisibility')}
      aria-pressed={isActive}>
      {isActive ? <Icon icon={ICONS.EyeCrossed} disableCommonColors /> : <Icon icon={ICONS.Eye} disableCommonColors />}
    </button>
  );
};

export default memo(EyeButton);
